import { FC, MouseEvent } from 'react';

import { CancelButton } from './buttons/CancelButton';
import { OkButton } from './buttons/OkButton';

type Props = {
  onNo: (event: MouseEvent<HTMLButtonElement>) => void;
  onYes: (event: MouseEvent<HTMLButtonElement>) => void;
  title: string;
};

export const ConfirmationPopup: FC<Props> = ({ onNo, onYes, title, children }) => {
  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75" />
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div className="hidden sm:block absolute top-0 right-0 pt-2 pr-2">
            <button type="button" onClick={onNo} className="bg-transparent text-gray-400 hover:text-gray-500 focus:outline-none hover:bg-transparent">
              <span className="sr-only">Close</span>
              <i className="fas fa-times text-2xl" />
            </button>
          </div>
          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center sm:mx-0 sm:h-10 sm:w-10 ">
              <span className="fa-stack text-lg">
                <i className="fas fa-circle fa-stack-2x text-red-100" />
                <i className="fas fa-exclamation-triangle fa-stack-1x text-lg text-red-600 -mt-0.5" />
              </span>
            </div>
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">{ title }</h3>
              <div className="mt-2">{ children }</div>
            </div>
          </div>
          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <OkButton onClick={onYes} color='red' />
            <CancelButton onClick={onNo} />
          </div>
        </div>
      </div>
    </div>
  );
};
